import React from "react";
import { useGoogleLogin } from "@react-oauth/google";

import GoogleIcon from "../../../../shared/components/Icons/GoogleIcon";

const LoginWithGoogle = ({ onLoginWithGoogleClick }) => {
  const login = useGoogleLogin({
    onSuccess: ({ access_token }) => {
      onLoginWithGoogleClick({ accessToken: access_token });
    },
  });

  return (
    <div className="account__btns ml-0" onClick={() => login()}>
      <div className="mb-0 p-0 account__btn oaut-g-btn oauth-btn-container">
        <GoogleIcon />
        <p className="custom-google-btn">sign in with google </p>
      </div>
    </div>
  );
};

export default LoginWithGoogle;
